export * from '@/config/device';
export * from '@/config/awsRum';
export * from '@/config/uiElementsPerIridiumVar';
export * from '@/config/queryKeys';

export const ROUTE_PREFIX = (process.env.REACT_APP_ROUTE_PREFIX as string) || '/';
export const API_URL = (process.env.REACT_APP_API_URL as string) || 'http://localhost:3000';
export const storagePrefix = 'spotter-dashboard-v2-';
export const globalStoreName = 'spotter-dashboard-v2-store';
export const SUBSCRIPTION_PLAN_MONTHLY = 'month';
export const SUBSCRIPTION_PLAN_ANNUALLY = 'year';
export const QUERIES_REFETCH_INTERVAL = 1000 * 60 * 3; // 3 minutes
export const WAVELINK_URL = (process.env.REACT_APP_WAVELINK_URL as string) || 'http://localhost:3030';
export const CHAT_SERVER_URL = (process.env.REACT_APP_CHAT_SERVER_URL as string) || 'http://localhost:3040';
export const DEFAULT_HISTORICAL_DATA_DATE_RANGE_DISTANCE_DAYS = 3;
/**
 * The longest range the historical charts will load.
 *
 * Six consecutive calendar months come to 184 days at their longest, so any six full months fit under
 * this cap whichever month they start in.
 *
 * The settled window is cut into chunks whose width grows with the span only up to the widest of
 * `SETTLED_CHUNK_HOURS`, past which a wider range is cut into more pieces instead. The request count each
 * chart section issues therefore grows with the span, and this cap is what bounds it: 185 days at 24 hour
 * chunks is 185 requests per section.
 */
export const MAX_HISTORICAL_DATA_DATE_RANGE_DAYS = 185;
export const RECURRING_SATELLITE_CREDITS_PRICE_LOOKUP_KEY = 'spotter.telemetry_credits.recurring';
export const ONETIME_SATELLITE_CREDITS_PRICE_LOOKUP_KEY = 'spotter.telemetry_credits.one_off';
export const ACCOUNT_BALANCE_CREDIT_PRICE_LOOKUP_KEY = 'account_balance.credit.dollar';
